const themeKey = 'timetable.darkMode';

function readDarkMode() {
  try {
    return window.localStorage.getItem(themeKey) === 'true';
  } catch (error) {
    return false;
  }
}

const storageKey = 'timetable.sidebarCollapsed';

function readSidebarPreference() {
  try {
    return window.localStorage.getItem(storageKey) === 'true';
  } catch (error) {
    return false;
  }
}

export default {
  namespaced: true,
  state: {
    sidebarCollapsed: readSidebarPreference(),
    darkMode: readDarkMode(),
  },
  mutations: {
    toggleDarkMode(state) {
      state.darkMode = !state.darkMode; // eslint-disable-line no-param-reassign
      try {
        window.localStorage.setItem(themeKey, String(state.darkMode));
      } catch (error) {
        // Switching themes remains available without browser storage.
      }
    },
    toggleSidebar(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed; // eslint-disable-line no-param-reassign
      try {
        window.localStorage.setItem(storageKey, String(state.sidebarCollapsed));
      } catch (error) {
        // The sidebar still works when browser storage is unavailable.
      }
    },
  },
};
